<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "@/assets/css/style.css";
import "@/assets/css/popup.scss";
import "@/assets/css/bootstrap.min.css";
import "@/assets/vendor/boxicons/css/boxicons.min.css";

export default {
  name: "App",
};
</script>
